import { ref } from "vue";
import useActivationTelegram from "@/components/activation/api/useActivationTelegram";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

// TODO: .env
const wsPath = "wss://wss.e-chat.tech:4433";

export default function useSocketActivation() {
    const store = useStore();
    const route = useRoute();

    const {
        getLinkActivationTelegram,
        payloadLinkActivationTelegram,
        serverId,
        getStatusActivationTelegram,
        statusNumberActivation,
    } = useActivationTelegram();

    const socketStatus = ref("");
    const socketNumberTelegram = ref("");
    let killSocket;

    const socketActivation = (id) => {
        if (!id && id !== 0) {
            socketStatus.value = "errorActivation";
            throw new Error("id is required");
        }
        try {
            const socket = new WebSocket(wsPath);
            // killSocket = socket.close();
            if (id === 0) socket.close();


            const getLink = async () => {
                await getLinkActivationTelegram(id);
                switch (payloadLinkActivationTelegram.value) {
                    case "activated":
                    case "timeOver":
                    case "oops":
                        socket.close();
                        break;
                }
                socketStatus.value = payloadLinkActivationTelegram.value;
            };

            socket.onopen = async (event) => {
                socket.send(JSON.stringify({ Id: id }));
                getLink();
            };

            socket.onmessage = async function (event) {

                const data = JSON.parse(event.data);
                const { message } = data;
                let description;

                if (message.status.indexOf("|") !== -1) {
                    const separateArray = message.status.split("|");
                    description = separateArray[0]?.trim();
                    // const number = separateArray[1]?.trim();
                } else {
                    description = message.status;
                }
                switch (description) {
                    case "Check QR":
                        if (route?.name === "ActivationTelegram") {
                            getLink();
                        } else {
                            socket.close();
                        }
                        break;
                    case "Refresh QR":
                        break;
                    case "QR timeout":
                        socketStatus.value = "timeOver";
                        store.commit("closeDialog");
                        socket.close();
                        break;
                    // socket.close()
                    case "Invalid number activated":
                    case "Existing number activated":
                    case "Number already activated":
                    case "Number successfully activated":
                    case "Two-factor authentication":
                        const lastStatus = statusNumberActivation.value;
                        getStatusActivationTelegram(id, serverId.value).then(
                            () => {
                                socketNumberTelegram.value = message.number;
                                if (!!statusNumberActivation.value) {
                                    if (
                                        statusNumberActivation.value ===
                                        lastStatus
                                    ) {
                                        statusNumberActivation.value =
                                            "twoFactorAuth2";
                                    }
                                    socketStatus.value =
                                        statusNumberActivation.value;
                                }
                            }
                        );
                        break;
                    default:
                        socketStatus.value = message.status;
                        break;
                }
            };
            return socket.close;
        } catch (error) {
            console.error("socket ERROR", error);
        }
    };

    return {
        socketStatus,
        socketActivation,
        socketNumberTelegram,
        killSocket,
    };
}
